import React from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SuccessOverlay } from './AgentSuccessModal.style';

const AgentSuccessModal = ({
  desc = 'Congratulations, your agent is active successfully, you can start using it.',
  noBtn,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <SuccessOverlay onClick={() => onClose?.()}>
      <div className="card" onClick={e => e.stopPropagation()}>
        <div className="icon-wrap">
          <Check size={28} />
        </div>
        <h3>Agent Created!</h3>
        <p>{desc}</p>
        {!noBtn && (
          <button type="button" className="continue" onClick={() => navigate('/agents')}>
            Continue to agents
          </button>
        )}
      </div>
    </SuccessOverlay>
  );
};

export default AgentSuccessModal;
